module.exports = __webpack_public_path__ + "img/product_23.fcaf13a.svg";